import { Injectable } from '@angular/core';

import { PrismicDataResponse } from '@dav-model/api/response/prismic-response.model';
import * as prismic from '@prismicio/client';
import { Client } from '@prismicio/client';
import { Query } from '@prismicio/types';
import { from, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class PrismicService {
  private _apiEndpoint = 'https://phoenix-ui.cdn.prismic.io/api/v2';
  private _accessToken: string = environment.prismicAccessToken;
  private readonly _uid: string = environment.prismicUid;
  private readonly _prismicTypeId: string = environment.prismicTypeId;

  private _client: Client = prismic.createClient(this._apiEndpoint, { accessToken: this._accessToken });

  getPrismicData(): Observable<PrismicDataResponse> {
    return from(
      this._client.get({ filters: [prismic.filter.at(this._prismicTypeId, this._uid)] }),
    ).pipe(map((response: Query) => response as unknown as PrismicDataResponse));
  }
}
